import clsx from 'clsx';
import './Loader.scss';

type LoaderProps = {
	className?: string;
	size?: 'xs' | 'sm' | 'default';
	theme?: 'light' | 'dark';
};

export function Loader({ className, size = 'default', theme = 'light' }: LoaderProps) {
	return <div className={clsx('[ loader ]', className)} data-size={size} data-theme={theme} />;
}
